var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CheckIn',{attrs:{"title":`${_vm.$t('form.label.forecast')}`},on:{"update-parent":_vm.updateParentEmitter}})
}
var staticRenderFns = []

export { render, staticRenderFns }